import { render, staticRenderFns } from "./orderTotalAside.vue?vue&type=template&id=16850f62"
import script from "./orderTotalAside.vue?vue&type=script&lang=js"
export * from "./orderTotalAside.vue?vue&type=script&lang=js"
import style0 from "./orderTotalAside.vue?vue&type=style&index=0&id=16850f62&lang=sass&scope=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3875257498/src/codestar-connections.ap-northeast-1.amazonaws.com/git-http/364953906322/ap-northeast-1/84d36ee7-16b8-4e80-bff0-7e6a249efe8b/OwlTing/owlnest_booking_engine/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16850f62')) {
      api.createRecord('16850f62', component.options)
    } else {
      api.reload('16850f62', component.options)
    }
    module.hot.accept("./orderTotalAside.vue?vue&type=template&id=16850f62", function () {
      api.rerender('16850f62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/orderTotalAside.vue"
export default component.exports